"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpStudentStandardsPerformance = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = require("styled-components");
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var orderBy_1 = __importDefault(require("lodash/orderBy"));
var isUndefined_1 = __importDefault(require("lodash/isUndefined"));
var react_i18next_1 = require("react-i18next");
var api_1 = require("../../../api");
var chartTypes_enum_1 = require("../Charts/chartTypes.enum");
var DpSectionCard_1 = require("../Cards/DpSectionCard");
var DpBarChartGrouped_1 = require("../BarChartGrouped/DpBarChartGrouped");
var DpStudentStandardsPerformance_styled_1 = require("./DpStudentStandardsPerformance.styled");
var DpStudentStandardsPerformanceHeader_1 = __importDefault(require("./DpStudentStandardsPerformanceHeader"));
var DataTableModal_1 = require("../DataTableModal/DataTableModal");
var format_percentage_helper_1 = require("../../../api/helpers/format-percentage.helper");
var DpStudentStandardsPerformance = function (_a) {
    var studentStandardsPerformance = _a.studentStandardsPerformance, classStandardsPerformance = _a.classStandardsPerformance;
    // --------------------------- State
    var _b = (0, react_1.useState)(false), initialized = _b[0], setInitialized = _b[1];
    var _c = (0, react_1.useState)([]), reportData = _c[0], setReportData = _c[1];
    var _d = (0, react_1.useState)([]), labels = _d[0], setLabels = _d[1];
    var _e = (0, react_1.useState)(false), showReportModal = _e[0], setShowReportModal = _e[1];
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var chartTitle = t('studentStandardsPerformance.title');
    var themeContext = (0, react_1.useContext)(styled_components_1.ThemeContext);
    var baseDataset = {
        type: 'bar',
        maxBarThickness: 15,
        minBarThickness: 15,
        barPercentage: 0.9,
        categoryPercentage: 0.3,
    };
    var headers = [
        {
            headerName: t('studentStandardsPerformance.dataTable.standard'),
            key: 'legend',
            sortable: true,
        },
        {
            headerName: t('studentStandardsPerformance.dataTable.studentAverange'),
            key: 'performanceStudent',
        },
        {
            headerName: t('studentStandardsPerformance.dataTable.classAverage'),
            key: 'performanceClass',
        },
    ];
    var parseReportData = function () {
        var sortedStandardsPerformance = (0, orderBy_1.default)(studentStandardsPerformance.standardsPerformance, ['mostRecentlyAssessDate', 'percentage'], ['desc', 'desc']).slice(0, 7);
        var formattedLabel = sortedStandardsPerformance.map(function (_a) {
            var standard = _a.standard;
            return (0, api_1.getShortCodeFromGlobalId)(standard);
        });
        setLabels(formattedLabel);
        var studentPerformances = sortedStandardsPerformance.map(function (_a) {
            var percentage = _a.percentage;
            return percentage;
        });
        var studentColor = (0, api_1.findPerformanceBandColor)(themeContext, (0, api_1.getCurriculumPrefixFromCurriculum)(api_1.CurriculumId.EurekaMath), api_1.Bands.Proficient);
        var classColor = (0, api_1.findPerformanceBandColor)(themeContext, (0, api_1.getCurriculumPrefixFromCurriculum)(api_1.CurriculumId.EurekaMath), api_1.Bands.None);
        var classPerformances = sortedStandardsPerformance.map(function (_a) {
            var standard = _a.standard, attempted = _a.attempted;
            return attempted
                ? classStandardsPerformance.standardsPerformance.find(function (standardPerformance) { return standardPerformance.standard === standard; }).percentage
                : 0;
        });
        var datasets = [
            __assign({ data: studentPerformances, backgroundColor: studentColor, hoverBackgroundColor: studentColor }, baseDataset),
            __assign({ data: classPerformances, backgroundColor: classColor, hoverBackgroundColor: classColor }, baseDataset),
        ];
        setReportData(datasets);
        setInitialized(true);
    };
    (0, api_1.useMount)(function () {
        if (!(0, isEmpty_1.default)(classStandardsPerformance) && !(0, isUndefined_1.default)(studentStandardsPerformance)) {
            parseReportData();
        }
    });
    var closeModal = function () {
        setShowReportModal(false);
    };
    var openReport = function () {
        setShowReportModal(true);
    };
    var header = (0, jsx_runtime_1.jsx)(DpStudentStandardsPerformanceHeader_1.default, { openReport: openReport });
    var reportDataTable = labels.map(function (element, index) { return ({
        legend: element,
        performanceStudent: "".concat((0, format_percentage_helper_1.formatPercentage)(reportData[0].data[index]), "%"),
        performanceClass: "".concat((0, format_percentage_helper_1.formatPercentage)(reportData[1].data[index]), "%"),
    }); });
    var legendReferences = ((0, jsx_runtime_1.jsx)("div", { className: "title-legend", children: (0, jsx_runtime_1.jsxs)("div", { className: "legend", children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("span", { className: "rounded-circle student" }), (0, jsx_runtime_1.jsx)("span", { className: "title", children: t('studentStandardsPerformance.student') })] }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("span", { className: "rounded-circle class-average" }), (0, jsx_runtime_1.jsx)("span", { className: "title", children: t('studentStandardsPerformance.classAverage') })] })] }) }));
    return (initialized && ((0, jsx_runtime_1.jsxs)(DpStudentStandardsPerformance_styled_1.StyledStudentStandardsPerformance, { "data-testid": "student-standards-performance", children: [(0, jsx_runtime_1.jsx)(DpSectionCard_1.DpSectionCard, { title: header, children: (0, jsx_runtime_1.jsxs)("div", { className: "report", children: [(0, jsx_runtime_1.jsx)(DpBarChartGrouped_1.DpBarChartGrouped, { labels: labels, ariaLabel: t('studentStandardsPerformance.chartAriaLabel', { count: labels.length }), type: chartTypes_enum_1.LibraryChartTypes.Bar, id: "grouped-standard-performance-student", datasets: reportData }), legendReferences] }) }), (0, jsx_runtime_1.jsx)(DataTableModal_1.DataTableModal, { show: showReportModal, closeHandler: closeModal, title: chartTitle, tableData: reportDataTable, headers: headers })] })));
};
exports.DpStudentStandardsPerformance = DpStudentStandardsPerformance;
exports.default = exports.DpStudentStandardsPerformance;
